import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type NotificationDetailsFragment = { id: string, createdAt: string, message: string, icon?: string | null, redirectPath: string, status: Types.UserNotificationStatusEnum, userProfileIcon?: string | null, type: Types.NotificationActionTypeEnum, quotedMessage?: string | null };


export type NotificationDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const NotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment NotificationDetails on BaseUserNotification {
  id
  createdAt
  message
  icon
  redirectPath
  status
  userProfileIcon
  type
  quotedMessage
}
    `;